import { ColorModifierTypes } from '@tokens-studio/types'

export const getModifyColorTypes = (): ColorModifierTypes[] => {
  return [ColorModifierTypes.DARKEN, ColorModifierTypes.LIGHTEN, ColorModifierTypes.ALPHA]
}
